import axios, { AxiosRequestConfig } from "axios";
import store from "@lhd/app/store";
import { userLogout } from "@lhd/features/users/usersSlice";
import {
  getAccessToken,
  getClient,
  getCompanyId,
  getUid,
  removeCookie,
  setCookie,
} from "@lhd/utility";
import { setAxiosLoading } from "@lhd/hooks";
import { disconnectSharedCable } from "./actionCable";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const persistAuthHeaders = (headers?: Record<string, any>) => {
  const accessToken = headers?.["access-token"];
  const client = headers?.client;
  const uid = headers?.uid;
  const expiry = headers?.expiry;

  const currentExpiry = localStorage.getItem("expiry");
  if (expiry && currentExpiry) {
    if (Number(expiry) < Number(currentExpiry)) {
      return;
    }
  }

  if (accessToken) setCookie("access_token", accessToken);
  if (client) localStorage.setItem("client", client);
  if (uid) localStorage.setItem("uid", uid);
  if (expiry) localStorage.setItem("expiry", expiry);
};

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config: AxiosRequestConfig): AxiosRequestConfig {
    // Track loading start with URL
    const url = config.url || "";
    setAxiosLoading(true, url);

    if (config.headers) {
      config.headers = {
        ...config.headers,
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      };

      if (getAccessToken()) {
        config.headers = {
          ...config.headers,
          "access-token": getAccessToken(),
          client: getClient(),
          uid: getUid(),
          "ngrok-skip-browser-warning": "true",
          "X-Login-Company-Id": getCompanyId(),
        };
      }
    }
    return config;
  },

  function (error) {
    // Track loading end on error
    const url = error?.config?.url || "";
    setAxiosLoading(false, url);
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Track loading end on success with URL
    const url = response?.config?.url || "";
    setAxiosLoading(false, url);
    persistAuthHeaders(response?.headers);

    return response;
  },

  function (error) {
    // Track loading end on error with URL
    const url = error?.config?.url || "";
    setAxiosLoading(false, url);

    // notification["error"]({
    //   message: "保存に失敗しました。",
    // });
    if (error?.response?.status === 401) {
      disconnectSharedCable();
      store.dispatch(userLogout());
      localStorage.clear();
      removeCookie("access_token");
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
